const e = {
  add: "Aggiungi",
  cancel: "Annulla",
  clear: "Rimuovi",
  confirm: "Conferma",
  delete: "Elimina",
  redo: "Ripeti",
  save: "Salva",
  saveAs: "Salva come",
  undo: "Annulla"
}, a = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, o = {
  cancel: "Annulla",
  confirm: "Conferma",
  datePlaceholder: "Seleziona data",
  datetimePlaceholder: "Seleziona data e ora",
  endDatePlaceholder: "Data di fine",
  endDatetimePlaceholder: "Data e ora di fine",
  endMonthPlaceholder: "Mese di fine",
  monthPlaceholder: "Seleziona Mese",
  now: "Ora",
  quarterPlaceholder: "Seleziona Trimestre",
  selectDate: "Seleziona data",
  selectTime: "Seleziona l'ora",
  startDatePlaceholder: "Data di inizio",
  startDatetimePlaceholder: "Data e ora di inizio",
  startMonthPlaceholder: "Mese di inizio",
  today: "Oggi",
  weekPlaceholder: "Seleziona settimana",
  yearPlaceholder: "Seleziona anno",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, l = {
  placeholder: "Seleziona"
}, i = {
  clear: "Rimuovi",
  negativeText: "Annulla",
  now: "Ora",
  placeholder: "Seleziona l'ora",
  positiveText: "OK"
}, t = {
  placeholder: "Inserisci"
}, n = {
  placeholder: "Inserisci"
}, r = {
  placeholder: "Inizia a digitare..."
}, c = {
  allRows: "Tutti le righe",
  default: "Predefinito",
  deleteLayoutDescription: "Vuoi davvero eliminare questo layout?",
  discardChanges: "Scarta modifiche",
  discardLayoutChanges: "Scarta modifiche al layout",
  enterLayoutName: "Inserisci nome del layout",
  enterRowNumber: "Inserisci numero di righe",
  fieldsSelected: "campi selezionati",
  freezeColumnDescription: "Blocca la colonna a sinistra",
  freezeUptoColumn: "Blocca fino alla colonna",
  frozen: "Bloccato",
  layoutName: "Nome Layout",
  manageColumns: "Gestisci colonne",
  none: "Nessuno",
  reorderRows: "Riordina righe",
  rowsSelected: "righe selezionate",
  saveLayoutAs: "Salva layout come",
  saveLayoutNew: "Salva nuovo layout",
  search: "Cerca",
  searchColumnsPlaceholder: "Cerca colonne",
  searchFieldsPlaceholder: "Campi di ricerca",
  selectAll: "Seleziona tutto",
  setTableHeight: "Imposta altezza della tabella",
  unfreeze: "Sblocca",
  unsavedChanges: "Alcune modifiche non sono state salvate",
  unsavedChangesDescription: "Potrebbero esserci una o più modifiche non salvate. Vuoi salvarle?"
}, s = {
  at: "a",
  colorAlreadyUsed: "Scegli una tonalità diversa o usa quella esistente",
  colorNamePlaceholder: "Inserisci nome",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Scegli un nome di colore diverso",
  noColorsAdded: "Non hai nessun colore in questa sezione."
}, d = {
  searchPlaceholder: "Cerca"
}, u = {
  invalidPastedData: "Dati incollati non validi"
}, p = {
  of: "di",
  page: "Pagina",
  rowsPerPage: "Righe per pagina"
}, m = {
  failedToUpload: "Caricamento non riuscito",
  retry: "Riprova",
  clickToUpload: "fai clic su Carica",
  orDragAndDrop: "O Trascina e goccia",
  supportedFileTypes: "Tipi di File supportati:"
}, h = {
  global: e,
  Progress: a,
  DatePicker: o,
  Select: l,
  TimePicker: i,
  Input: t,
  InputNumber: n,
  InputTag: r,
  HLDataTable: c,
  ColorPicker: s,
  InputPhone: d,
  InputOtp: u,
  Pagination: p,
  Upload: m
};
export {
  s as ColorPicker,
  o as DatePicker,
  c as HLDataTable,
  t as Input,
  n as InputNumber,
  u as InputOtp,
  d as InputPhone,
  r as InputTag,
  p as Pagination,
  a as Progress,
  l as Select,
  i as TimePicker,
  m as Upload,
  h as default,
  e as global
};
